/** Presentation only: the charging-cable hit does not change simulation rules. */
export const CHARGE_SPARKS = {
  duration: 2.8,
  count: 180,
  emissionDuration: 1.1,
  lifetime: [0.55, 1.25],
  speed: [2.5, 6.5],
  gravity: 9.8,
  trailSeconds: 0.045,
  thickness: 0.016,
  arcDuration: 1.5,
  arcSegments: 24,
  arcThickness: 0.018,
  arcJitter: 0.13,
  arcRefreshHz: 24,
  lightIntensity: 24,
  lightDistance: 9,
  glowSize: 1.8,
  seed: 0x57494e4b,
} as const;
